import { useCallback } from "react";
import { useIntl } from "react-intl";
import { CommentActions } from "@crunchyroll/cx-web-components";

import { useCommentMutations } from "../hooks/useCommentMutations";
import { useComments } from "../hooks/useComments";
import formattedLikeCount from "../../../packages/@crunchyroll/formatted-like-count";
import { useRestrictionModal } from "../../modals/hooks";

const CommentLike = ({ id }) => {
  const { byId } = useComments();
  const comment = byId[id];
  const { likeComment, unlikeComment } = useCommentMutations(id);
  const { isLiked, likesCount } = comment;
  const handleLikeClick = useCallback(() => {
    if (isLiked) {
      unlikeComment();
    } else {
      likeComment();
    }
  }, [isLiked, likeComment, unlikeComment]);
  const { wrapHandler } = useRestrictionModal();
  const intl = useIntl();

  return (
    <CommentActions.Like
      isLiked={isLiked}
      onClick={wrapHandler(handleLikeClick)}
      label={
        likesCount > 0
          ? intl.formatMessage(
              { id: "comment.like_number" },
              formattedLikeCount(likesCount)
            )
          : intl.formatMessage({ id: "comment.like" })
      }
    />
  );
};

export default CommentLike;
